<template lang="html">
  <div class="admin-vacancies-scene">
    <router-view></router-view>
  </div>
</template>

<script>
  import { STORE_PREFIX } from '../constants.js';
  export default {
    name: 'admin-company-settings',

    props: ['companyId'],

    methods: {
      fetch () {
        this.$store.dispatch(STORE_PREFIX + 'admin/company/fetch', this.companyId)
      }
    },

    beforeMount() {
      this.fetch();
    }
  }
</script>

<style lang="scss" scoped>

  .pagination:first-child {
    padding: 0 0 20px 0;
  }
</style>
